import { HomeState } from "../types";

const state: HomeState = {
  isPromptingForCancel: false,
};

export default state;
